import { InlineStack, Tag, Text } from '@customerio/pluma-components/react';
import type { Tag as TagRecord } from '@customerio/hydra-ui-api';

/** How many tags a cell shows before collapsing the rest into a count. */
const MAX_DISPLAY_TAGS = 2;

export type TagsCellProps = {
  tags: readonly TagRecord[];
};

/** A row's tags as they read when nobody is editing them. */
export function TagsCell({ tags }: TagsCellProps) {
  if (tags.length === 0) {
    // Muted: this dash stands where a row nobody may tag would otherwise
    // read "Add tags", and the page this replaces greys it out with the
    // disabled button it sits in.
    return <Text color="placeholder">-</Text>;
  }

  const shown = tags.slice(0, MAX_DISPLAY_TAGS);
  const remaining = tags.length - shown.length;

  return (
    <InlineStack alignBlock="center" gap="050">
      {shown.map((tag) => (
        <Tag key={tag.id}>{tag.name}</Tag>
      ))}
      {remaining > 0 ? <Tag>+{remaining}</Tag> : null}
    </InlineStack>
  );
}
